import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const FocusInspectionButtonWeb = ({ title, subtitle, subTitleColor }) => {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="fit-content">
      <Box
        onClick={() => navigate('/inspection-booking')}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(90deg, #F1761B 0%, #FF5100 100%)',
          borderRadius: '10px',
          px: 4,
          py: 1.5,
          cursor: 'pointer',
          width: 'fit-content',
          textAlign: 'center',
          height: 'fit-content',
          minWidth: '327px',
        }}
        role="button"
        tabIndex={0}
      >
        <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#fff' }}>{title}</Typography>
      </Box>

      {subtitle && (
        <Typography
          component="div"
          textAlign="center"
          sx={{ fontSize: '12px', color: subTitleColor || '#FFFFFF', mt: 0.5 }}
        >
          <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
            <span style={{ marginTop: '2px' }}>{subtitle}</span>
          </Stack>
        </Typography>
      )}
    </Box>
  );
};

FocusInspectionButtonWeb.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitleColor: PropTypes.string,
};

export default FocusInspectionButtonWeb;
